/* eslint-disable import/no-unresolved */
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    useLazyQuery, useMutation, useQuery, useReactiveVar,
} from '@apollo/client';

import { CREATE_FFIEC041_USER_COMMENT, DELETE_FFIEC041_USER_COMMENT, UPDATE_FFIEC041_USER_COMMENT } from 'Apollo/Mutations/Rules/FFIEC041';
import { GET_USER_INFO } from 'Apollo/Queries';
import { GET_COMMENTS_FOR_FFIEC041 } from 'Apollo/Queries/Rules/FFIEC041Results';
import { tenantIdVar } from 'Apollo/config';
import FFIEC041Comment from '../components/FFIEC041Comment';

const FFIEC041Comments = ({ refetch }) => {
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);
    const [ffiec041Comment, setFfiec041Comment] = useState('');
    const [ffiec041Show, setFfiec041Show] = useState(false);
    const [ffiec041Target, setFfiec041Target] = useState(null);
    const [ffiec041Edit, setFfiec041Edit] = useState(false);
    const [ffiec041SelectedComment, setFfiec041SelectedComment] = useState('');
    const [ffiec041SelectedCommentID, setFfiec041SelectedCommentID] = useState('');
    const [ffiec041SelectedIndex, setFfiec041SelectedIndex] = useState(null);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo query to fetch user information  */
    const getFFIEC041User = useQuery(GET_USER_INFO);

    /* Apollo lazy query to fetch all the comments  */
    const [getComments, { loading, data: { getUserCommentsForFFIEC041 = {} } = {} }] = useLazyQuery(GET_COMMENTS_FOR_FFIEC041, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                tenantId: parseInt(tenantId, 10),
            },
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo mutation to add new comment  */
    const [addResultComment, { loading: commentLoading }] = useMutation(CREATE_FFIEC041_USER_COMMENT, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                tenantId: parseInt(tenantId, 10),
                commentText: ffiec041Comment,
            },
        },
    });

    /* Apollo mutation to delete a comment  */
    const [deleteComment] = useMutation(DELETE_FFIEC041_USER_COMMENT);

    /* Apollo mutation to update comment  */
    const [updateComment] = useMutation(UPDATE_FFIEC041_USER_COMMENT);

    /* Comment option handler */
    const handleFFIEC041Click = (index, text, commentId, event) => {
        setFfiec041Show(!ffiec041Show);
        setFfiec041SelectedIndex(index);
        setFfiec041SelectedComment(text);
        setFfiec041SelectedCommentID(commentId);
        setFfiec041Target(event.target);
    };

    /* Calls  addResultComment(), getComments() and refetch that failed tests result */
    const addFFIEC041Comment = async () => {
        await addResultComment();
        getComments();
        refetch();
        setFfiec041Comment('');
    };

    /* Toggled edit value */
    const onFFIEC041EditClick = () => {
        setFfiec041Edit(!ffiec041Edit);
    };

    /* Cancal button handler */
    const onFFIEC041CancelClick = () => {
        setFfiec041Edit(!ffiec041Edit);
        setFfiec041SelectedIndex(null);
        setFfiec041SelectedComment('');
        setFfiec041Show(!ffiec041Show);
    };

    /* Calls updateComment and refetch the failed tests resut */
    const onFFIEC041ClickSave = async () => {
        await updateComment({
            variables: {
                input: {
                    commentText: ffiec041SelectedComment,
                    commentId: ffiec041SelectedCommentID,
                    tenantId: parseInt(tenantId, 10),
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setFfiec041Edit(!ffiec041Edit);
        setFfiec041SelectedIndex(null);
        setFfiec041SelectedComment('');
        setFfiec041Show(!ffiec041Show);
        refetch();
    };

    /* Calls deleteComment and refetch the failed tests resut */
    const onFFIEC041ClickDelete = async () => {
        await deleteComment({
            variables: {
                input: {
                    commentId: ffiec041SelectedCommentID,
                    tenantId: parseInt(tenantId, 10),
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setFfiec041SelectedIndex(null);
        setFfiec041SelectedComment('');
        setFfiec041Show(!ffiec041Show);
        refetch();
    };

    /* Side effect to fetch comments initially */
    useEffect(() => {
        getComments();
    }, []);

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
    }, [location]);

    return (
        <FFIEC041Comment
            getFFIEC041User={getFFIEC041User}
            ffiec041Comment={ffiec041Comment}
            setFFIEC041Comment={setFfiec041Comment}
            commentLoading={commentLoading}
            addFFIEC041Comment={addFFIEC041Comment}
            loading={loading}
            getUserCommentsForFFIEC041={getUserCommentsForFFIEC041}
            handleFFIEC041Click={handleFFIEC041Click}
            onFFIEC041EditClick={onFFIEC041EditClick}
            onFFIEC041ClickDelete={onFFIEC041ClickDelete}
            onFFIEC041CancelClick={onFFIEC041CancelClick}
            onFFIEC041ClickSave={onFFIEC041ClickSave}
            ffiec041Show={ffiec041Show}
            ffiec041Target={ffiec041Target}
            ffiec041Edit={ffiec041Edit}
            ffiec041SelectedComment={ffiec041SelectedComment}
            ffiec041SelectedCommentID={ffiec041SelectedCommentID}
            setFFIEC041SelectedComment={setFfiec041SelectedComment}
            ffiec041SelectedIndex={ffiec041SelectedIndex}
        />
    );
};

export default FFIEC041Comments;
